import { useEffect } from 'react';

// SPA pages render with HTTP 200, so a "not found" page is indexed by Google
// as a "Soft 404". Call this hook (active=true) to mark the current page
// noindex so Google excludes it instead of flagging it as an indexing error.
export function useNoIndexMeta(active = true) {
  useEffect(() => {
    if (!active) return;
    let meta = document.querySelector('meta[name="robots"]');
    const had = meta ? meta.getAttribute('content') : null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (had === null) {
        meta.remove();
      } else {
        meta.setAttribute('content', had);
      }
    };
  }, [active]);
}